export default {
    global: {
        close: 'Close',
        save: 'Save',
        continue : 'Continue',
        confirmAndSend: 'Confirm and send',
        mandatory_field: 'This field is required',
        checkbox_mandatory : 'This checkbox is required',
        cancel: 'Cancel',
        ok: 'Ok',
        yes: 'Yes',
        no: 'NO',
        post_success: 'Data sent well',
        code : 'CODE:'
    },
    menu: {
        main_menu: 'Main menu',
        lmra: 'Open/Close LMRA',
        report_incident: 'Report an incident',
        report_near_incident: 'Report a near incident',
        risk_analysis: 'Risk analysis',
        corona_analysis: 'Corona analysis',
        scan_qr: "Scan TAG/QR-CODE",
        process_issue: "Report process issue",
        checklist: "View checklist",
        log_in: "Sign in",
        log_out: "Sign out",
        emergency_numbers : "Emergency Numbers"
    },
    default_lrma: {
        what_label: 'Do I understand what to do?',
        how_label: 'Do I know how to do it?',
        risks_label: 'Do I recognize the dangers and risks?',
        control_label: 'Can I control it?',
        default_pbm_label: 'Do I have the correct PPE?',
        default_pbm_question: 'Do I have the correct PPE?|1',
        lmra_job_state_positive: 'Ok to start the work, we will review the LMRA when changes occur',
        lmra_job_state_negative: 'We are not yet starting work.',
    },
    static_three_state_lmra: {
        getting_data_title: "The latest version is being downloaded.",
        could_not_load_newest_list_title: 'Attention',
        could_not_load_newest_list: 'Something went wrong while getting the latest list. An older saved version of the list will be displayed so you can continue. If this problem persists, it is best to inform a responsible person.',
    },
    private_location: {
        title: 'Are you in a private location?',
        body: 'Private locations are locations outside work-related places.'
    },
    remarks: {
        remarksDialogTitle: 'Remarks?',
        remarksDialogPlaceholder: 'Type your remarks here',
    },
    start_stop_screen: {
        start_work_btn: "start working",
        stop_work_btn: "stop working",
    },
    work_report: {
        title: "Work report",
        placeholder: "Type your work report here",
        skip_work_report: "Skip",
        buildingListTitle : "We are building your work report form, this should not take too long.",
        criticalErrorTitle: 'Error:',
        criticalErrorBody: 'Something went wrong while creating your work report form! Please provide your manager with the error code below:',
    },
    incident_report: {
        title: "Report incident",
        placeholder: "What happened?",
    },
    oeps_report: {
        title: "Report near incident",
        placeholders: {
            machine: 'Which machine?',
            who: 'Who was involved?',
            what: 'What happened?',
            how: 'How did this happen / how did this happen?',
            stop_card: 'Select Stopcard',
            location: 'Select location',
            department: 'Select department'
        },
        external_employee: 'Is an external employee',
        when_text_label: 'When did this happen?',
        change_date_time_btn: 'Change date / time'
    },
    risk_analysis: {
        title: {
            risk_default: "Risk analysis",
            risk_default_sub_title: '',
            corona: "Corona analysis",
            corona_sub_title: 'Indicate your working conditions below and find out how to work safely.'
        },
        lists: {
            risk_default: {
                gravity: {
                    label: 'Gravity',
                    gravity_01: 'minor, injury without absenteeism',
                    gravity_02: 'important, injury and absenteeism',
                    gravity_07: 'severe, permanent disability / chronic conditions with (partial) incapacity for work',
                    gravity_15: 'very serious, 1 dead (acute in the long term)',
                    gravity_40: 'disaster, multiple deaths'
                },
                probability: {
                    label: 'Probability',
                    probability_0_1: 'almost impossible to imagine',
                    probability_0_2: 'practically impossible',
                    probability_0_5: 'imaginable, but unlikely',
                    probability_01: 'unlikely, borderline case',
                    probability_03: 'unusual, but possible',
                    probability_06: 'quite possible',
                    probability_10: 'expected'
                },
                exposure: {
                    label: 'Exposure',
                    exposure_0_5: 'very rare (1x per year)',
                    exposure_01: 'rarely (annually)',
                    exposure_02: 'sometimes (monthly)',
                    exposure_03: 'occasionally (weekly)',
                    exposure_06: 'regularly (daily)',
                    exposure_10: 'constantly',
                },
            },
            corona: {
                distance: {
                    label: 'Expected distance between me and others:',
                    distance_01: 'D > 8 m',
                    distance_02: '6 m < D < 8 m',
                    distance_07: '2 m < D < 6 m',
                    distance_15: '1,5 m < D < 2 m',
                    distance_40: '1 m < D < 1,5 m',
                    distance_100: 'D < 1 m'
                },
                probability: {
                    label: 'I notice that others ...',
                    probability_0_1: 'wear an FFP2 mask + goggles + protective clothing',
                    probability_0_2: 'wear an FFP2 mask + glasses',
                    probability_0_5: 'wear a mask or face shield',
                    probability_01: 'definitely respect the Corona Guidelines',
                    probability_03: 'maybe respect the Corona Guidelines',
                    probability_06: 'violate some Corona Guidelines',
                    probability_10: 'Violated multiple Corona Guidelines'
                },
                exposure: {
                    label: 'Chance of closer contact than expected:',
                    exposure_0_5: 'Very unlikely',
                    exposure_01: 'When several things go wrong',
                    exposure_02: 'Unusual, if certain things go wrong',
                    exposure_03: 'Possibly, chances are not that great',
                    exposure_06: 'Quite possible, reasonable chance',
                    exposure_10: 'To be expected, almost certainly',
                },
            },
        },
        results: {
            risk_default: {
                kinneyCode1: 'none',
                kinneyCode2: 'attention required',
                kinneyCode3: 'measures required can be planned',
                kinneyCode4: 'immediate improvement',
                kinneyCode5: 'stop working'
            },
            corona: {
                kinneyCode1: 'Acceptable risk: No additional protective measures required',
                kinneyCode2: 'Possible risk: Needs attention',
                kinneyCode3: 'Major risk: Take protective measures',
                kinneyCode4: 'High risk: Take increased protective measures',
                kinneyCode5: 'Very high risk: Try to adjust activity, if impossible then take maximum protective measures'
            },
        },
        supportive_texts: {
            risk_default: {
                supportiveText1: '',
                supportiveText2: '',
                supportiveText3: '',
                supportiveText4: '',
                supportiveText5: ''
            },
            corona: {
                supportiveText1: 'I know and respect the Corona Guidelines that apply in my work environment.',
                supportiveText2: 'I know and respect the Corona guidelines that apply. I expressly ask the people in my working environment to also comply with the Corona guidelines. No further additional protective measures are necessary.',
                supportiveText3: 'I was or disinfected hands at the start and end of the activity. I wear a face shield or a suitable mouth mask in combination with (safety) glasses. The people in my working environment must at least also wear a face shield or a nose mask (preferably together with safety goggles). I know how to use these collective protection equipment correctly and apply it in practice. I know and respect the Corona Guidelines that apply and I expressly ask the people in my work environment to also comply with the Corona Guidelines.',
                supportiveText4: 'I was or disinfected hands at the start and end of the activity and after any unsafe touch. I wear a protective mouth nose mask (preferably an FFP2 respiratory protection mask) in combination with a face shield or goggles. I know how to use these personal protective equipment (PPE) correctly and apply it in practice. I know the corona guidelines that apply in the working environment and of course continue to respect these Corona guidelines. I ask people in my working environment to also take the necessary safety measures and to observe the Corona guidelines.',
                supportiveText5: 'I first consider whether the activity can be carried out in another way without direct contact with other persons. If this is not possible, I will take all possible safety measures. I was or disinfected hands at the start and end of the activity. I wear protective gloves. I wear a respiratory protection mask (at least FFP2) in combination with a face shield or protective goggles and protective clothing. I know how to use these personal protective equipment (PPE) correctly and apply it in practice. I know the corona guidelines that apply in the working environment and of course continue to respect these Corona guidelines .. I ask people in my working environment to also take the necessary safety measures and to observe the Corona guidelines carefully.'
            }
        },
        leave_warning: {
            risk_default: {
                title: 'Attention',
                body: 'You are about to close this window without sending the current risk analysis report. Are you sure you want to leave the page?'
            },
            corona: {
                title: 'Attention',
                body: 'You are about to close this window without sending the current Corona analysis report. Are you sure you want to leave the page?'
            }
        },
        report_title: 'Analysis report',
        placeholder_report: 'Describe / clarify the situation'
    },
    process_issue: {
        title: "Report a Process Issue",
        placeholders: {
            issue_type_select: 'Select problem type',
            failure_detail: 'Select problem detail',
            who: 'Who was involved?',
            description: 'Describe the issue',
            cnf: 'CNF?',
            comment: 'Additional remarks / Comments',
            other: 'Other'
        }
    },
    checklist: {
        getting_data_title: "The latest checklist is collected."
    },
    data_transfer: {
        post_busy: 'Please wait, the data is being sent.',
        post_success: 'Data Sent well.'
    },
    gdpr_disclaimer: {
        title: 'GDPR Proposal:',
        body: 'Submitting an item of the lmra-first application the following items will be stored in the database: current location (GPS - coordinates (after confirmation)) and the exact time (and only at that time). None of those items will be sold to other parties, organisations. The data stored will only used in order of the project and related working conditions',
        accept_btn: 'I Accept',
        decline_btn: 'Leave App'
    },
    data_notice: {
        button_text: 'What happens with this information?',
        popup_title: '',
        popup_body: ''
    },
    cap_settings: {
        alert_cn_pid_nf_title: 'Oops looks like you forgot something:',
        alert_cn_pid_nf_body: 'Client name and/or Project ID not filled, please check values',
        client_select_placeholder: 'Select a client',
        project_select_placeholder: 'Select a Project',
        client_not_in_list_label : 'Client not in list',
        project_not_in_list_label : 'Project not in list',
        client_name: 'Client name',
        project_id: 'Project ID',
        project_distance: 'Project Distance',
        project_shift: 'Project Shift',
        user_initials: 'Your initials',
        project_tag_code_label : 'Project TAG-Code',
        warning: {
            intro: 'You are now using manual input for',
            reason_server: 'because server data could not be loaded!',
            reason_client_not_listed: 'because client was not in current list!',
            reason_project_not_listed: 'because project was not in current list!',
            dbl_check: 'Double check all your values before saving!',
            admin_msg: 'If this message continues to appear contact your administrator and report this!'
        },
        input_errors: {
            no_client_selected: 'Please select a client',
            no_project_selected: 'Please select a project',
        },
        loading_cap: 'Loading data from server',
        custom_shifts_labels: {
            open_field : 'Open field'
        }
    },
    tag_code_scanner: {
        global: {
            loading_stream: 'Loading camera stream ...',
            default_error_button_test : 'Exit'
        },
        overlay_view: {
            title : 'Scan TAG - Code',
            info_manual : 'Having trouble scanning? Use manual input',
            manual_btn : 'Enable manual input.',
            errors : {
                invalid_tag_title : 'Invalid TAG-CODE',
                invalid_tag_body : 'The Code you have scanned is not a valid TAG-CODE, scan a valid TAG-CODE or switch to manual input.',
                error_btn_txt : 'Enable Manual Input'
            }
        }
    },
    errors: {
        checklistNotLoaded: 'Something went wrong while getting the list, please try again later.',
        EmergencyNumbersOverviewNotLoaded: 'Something went wrong while getting the list, please try again later.',
        missing_critical_resource_title: 'Error loading data:',
        missing_critical_resource: 'A resource is missing from the application. Report the code below to the administrator.',
        app_corrupt: 'It appears that the application configuration is corrupted. Please contact your administrator.',
        data_save_failed: 'The data could not be sent, please try again later ...',
        camera: {
            NotAllowedError: 'ERROR: You must grant permission for camera access',
            NotFoundError: 'ERROR: No camera on this device',
            NotSupportedError: 'ERROR: secure context required (HTTPS, localhost)',
            NotReadableError: 'ERROR: Is the camera already being used?',
            OverconstrainedError: 'ERROR: Installed cameras are not suitable',
            StreamApiNotSupportedError: 'ERROR: Stream API is not supported in this browser',
        },
        no_internet: 'Oooops ... you are Offline, check your internet connection!',
        input_validation: {
            char_limit: 'A maximum of %n characters is allowed'
        },
        auth0 :{
            unverified_email : {
                error: 'Error: Email address is not verified! Check your emails!',
                info : 'In order to gain access to this application <b>you need to verify your e-mail address</b>.<br/><br/>You will <b>receive an e-mail</b> shortly <b>from |SENDER| </b><br/><br/><i>To verify your e-mail address. Follow the instructions in the email</i>'
            }
        }
    },
    noDataText: "Data not available ...",
    defaultDynamicQuestion: '{"dynamic_questions":[{"id":null,"question":"Do I have the correct PPE?","correct_answer":"1"}]}',
    auth : {
        emailLabel: 'Email',
        passwordLabel : 'Password',
        rememberMeLabel : "Remember me",
        logInBtn: "Sign in",
        logOutBtn: "Sign out",
        verifyMFABtn : "Verify",
        errorPopupTitle : "Error",
        confirmIdentify : "Still You?",
        errors :{
            required : "Required",
            invalidEmail : "Invalid e-mail",
            unknownError : "An unknown error occurred"
        },
        registerNewAccountBtn : "Create a new account.",
        forgotPassword : "Forgot password"
    },
    lmraComponent : {
        loadingProjectData : 'Preparing your LMRA form, please wait',
        errors : {
            unknownError : "An unknown error occurred",
            noListDataFound : "Error : NO LIST DATA FOUND!! FALL BACK TO DEFAULT LMRA",
            noDefaultListFound: 'No default list available! Using DEFAULT LMRA!',
        }
    },
    customLmraLists : {
        buildingListTitle : "Building your LMRA form, this shouldn't take too long.",
        criticalErrorTitle: 'Error:',
        criticalErrorBody: 'Something went wrong while constructing your LMRA form! We will now load the default LMRA! please provide your manager with the error code below : ',
    },
    workSessions :{
        global : {
          expiredLabel : "Expired"
        },
        resumeSessionDialog : {
            titleActiveSession : "Active Session Found",
            titleActiveSessionExpired : "(Expired) Active Session Found",
        },
        workSessionServiceNaDialog :{
            title : 'WORKSESSION SERVICE UNAVAILABLE',
            body : 'Sorry we are unable to determine if you have an open session<br/><br/>' +
                '<b>LMRA Module is locked:  you can not start or close a session. </b><br/> However you can still send incident reports (outside session)<br/>' +
                'You will receive a notification when session service is available<br/><br/>' +
                'if this error persists please notify your admin..'
        },
        lmraLocked : {
            lmraComponentLockedInfo : "Sorry: <b>THe LMRA Module is currently locked:  you can not start or close a session. </b>"
        },
        lmraVariants : {
            errors : {
                saving_session : {
                    missing_session_data : 'Server response does not contain session data',
                    could_not_save_session : 'Could not save session data locally...',
                    invalid_session_data : 'Session data invalid, data might be corrupted'
                }
            }
        }
    },
    whatsAppGroup : {
        errors : {
            unknown : "An unknown error occurred",
            notFound : "No group code found."
        }
    },
    emergency_numbers: {
        default_number_btn_txt : "Default Emergency Number",
        getting_data_title: "Getting latest numbers"
    },
    checklist_components :{
        main_checklist_component : {
            tabs : {
                active_checklist : "Active Checklist",
                other_checklists : "Other Checklists"
            }
        },
        checklist_detail_component : {
            toolbar:{
                title : "Viewing : "
            },
            warning_message : "You are viewing a checklist which is not the current active list. To view the active list use the tab \"Active checklist\" at the top"
        }
    },
    version_info : {
        update : {
            version_up_to_date : "Version is up to date",
            version_minor_update : "Newer version available (may not be available for your tenant)",
            update_required : "Warning! This app is outdated, the app should update automatically. If this message persists contact admin."
        }
    }
}